import React from "react";
import { useReveal } from "./Hooks";
import {
  RevealWrapper,
  CtaWrapper,
  CtaBgGrid,
  CtaRing,
  CtaContent,
  SectionLabel,
  CtaTitle,
  BtnCtaWhite,
} from "../Styles";
import { ArrowRightIcon } from "./Icons";
import useWebinar from "../../../../hooks/useWebinar";

function CtaSection() {
  const { ref, visible } = useReveal(0);

  const { config } = useWebinar();
  const ctaData = config?.cta;

  if (!ctaData?.show) return null;

  return (
    <CtaWrapper>
      <CtaBgGrid aria-hidden="true" />
      <CtaRing className="r1" aria-hidden="true" />
      <CtaRing className="r2" aria-hidden="true" />

      <RevealWrapper ref={ref} $visible={visible}>
        <CtaContent>
          <SectionLabel $light>{ctaData.label}</SectionLabel>
          <CtaTitle>{ctaData.title}</CtaTitle>
          <p>{ctaData.description}</p>
          <BtnCtaWhite href={ctaData.buttonHref}>
            {ctaData.buttonLabel}
            <ArrowRightIcon size={18} />
          </BtnCtaWhite>
          <p style={{ marginTop: 10 }}>
            Saturday, 4th April 2026 · 11:00 AM — 12:15 PM IST
          </p>
        </CtaContent>
      </RevealWrapper>
    </CtaWrapper>
  );
}

export { CtaSection };
